import { render, staticRenderFns } from "./Clinic.vue?vue&type=template&id=7a222dc4&scoped=true"
import script from "./Clinic.vue?vue&type=script&lang=js"
export * from "./Clinic.vue?vue&type=script&lang=js"
import style0 from "./Clinic.vue?vue&type=style&index=0&id=7a222dc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a222dc4",
  null
  
)

export default component.exports